module.exports = __webpack_public_path__ + "static/img/banner-personal.e12da3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-personal.jpg
// module id = RQiw
// module chunks = 16